import { useContext } from "react";
import logoHome from "../Assets/Logos/Logotipo_bg_BRK.svg";
import { HomeContext } from "../Context/ContextHome";
import { LogoBGStyled } from "../Styles/LogoBG";

export const LogoBG = () => {
  const { darkMode, setDarkMode } = useContext(HomeContext);

  return (
    <LogoBGStyled darkmode={darkMode}>
      <img src={logoHome} />
    </LogoBGStyled>
  );
};
